import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { history } from "./components/common/History";
import { appController } from "./controllers/app.controller";
import { logController } from "./controllers/log.controller";

import $ from "jquery";

// eslint-disable-next-line
import metismenu from "metismenu";

// import { Provider } from "react-redux";
// import store from "./redux/store";

import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.css";
import "animate.css/animate.min.css";
import "./style.css";

window.jQuery = $;
window.$ = $;
global.jQuery = $;

appController.getLastVersion().then((data) => {
    localStorage.setItem("version", data.version);
    logController.logMessage(`The server application version is ${data.version}.`);
});

appController.getLastInformationalVersion().then((data) => {
    localStorage.setItem("informationalVersion", data.version);
});

// eslint-disable-next-line
const bootstrap = require("bootstrap");

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

ReactDOM.render(
    <BrowserRouter basename={baseUrl} history={history} forceRefresh={true}>
        <App />
    </BrowserRouter>,
    rootElement
);

// Check that service workers are supported
if ("serviceWorker" in navigator) {
    // Use the window load event to keep the page load performant
    window.addEventListener("load", () => {
        navigator.serviceWorker.register("/service-worker.js");
    });
}



// WEBPACK FOOTER //
// ./src/index.js